import theme from "../../../js/shared/new-theme"

const palette = theme.palette;

export const defaultStyle = (hasError, type, withShadow) => {
	return `
	i {
		color: ${hasError ? palette.red[500].value : palette.gray[600].value};
	}
	label {
		color: ${palette.gray[600].value};
	}
	${type === "checkbox"
			? `
		input {
			& + label:before {
				border-color: ${hasError ? palette.red[500].value : palette.gray[400].value};
			}
			&:checked + label:before {
				background: ${palette.primary[700].value};
				border-color: ${palette.primary[400].value};
			}
			&:disabled + label {
				color: ${palette.gray[500].value};
			}
			&:disabled + label:before {
				border-color: ${palette.gray[100].value};
			}
			&:checked + label:after {
				box-shadow:
								2px 0 0 ${palette.common.white},
								4px 0 0 ${palette.common.white},
								4px -2px 0 ${palette.common.white},
								4px -4px 0 ${palette.common.white},
								4px -6px 0 ${palette.common.white},
								4px -8px 0 ${palette.common.white};
			}
		}
	`
			: ""
		}
	${type === "radio"
			? `
	input { 
		&:checked + label,
		&:checked + label:before,
		&:not(:checked) + label:before {
			border-color: ${hasError ? palette.red[500].value : palette.gray[600].value};
		}

		&:checked + label:before {
			border-color: ${palette.primary[400].value}
		}
		&:checked + label:after,
		&:not(:checked) + label:after {
			background: ${palette.primary[700].value};
		}
		&:disabled + label {
			color: ${palette.gray[500].value};
		}
		&:disabled + label:before {
			border-color: ${palette.gray[100].value};
		}
	}
	`
			: ""
		}
	${type !== "checkbox" && type !== "radio"
			? `
			input{
				border: 1px solid ${hasError ? palette.red[500].value : palette.gray[400].value};
				color: ${hasError ? palette.red[500].value : palette.gray[600].value};
				box-shadow: ${withShadow ? `4px 4px 0 ${palette.gray[1000].value}` : "none"};

				&:focus {
					color: ${hasError ? palette.red[500].value : palette.gray[600].value};
					border: 1px solid ${hasError ? palette.red[500].value : palette.gray[400].value};
				}
				&:disabled {
					background-color: ${palette.gray[100].value};
					color: ${palette.gray[500].value};
					pointer-events: none;      
				}
				&:disabled + i {
					color: ${palette.gray[500].value};
				}
			}
	`
			: ""
		}
`;
};
